import Swal from "sweetalert2";
import {email, whatsapp2} from "../../../../assets/images";
import {distinctByField} from "../../../../utils/sort";
import {getSelectedRows} from "../../../../ui-component/ag-grid/Ag-Table";
import {ExtendedDocument, isSupplierDocument} from "types/DocumentsTypes/Document";
import JSDB from "../../../../fromKotlin/nk";
import {hashIsraelSignBulk, massSendFilesOf} from "../../../../api/customer/documents.api";
import {getTranzilaConfig} from '../../../../api/customer/tranzila.api';
import {
    collectPayableDocsFromDocuments,
    groupPayableByClient,
    paymentSendPayload,
} from '../../../../utils/paymentLinkDocs';

function startOfDay(d: Date): Date {
    const x = new Date(d);
    x.setHours(0, 0, 0, 0);
    return x;
}

function orderDateForDocs(orders: ExtendedDocument[]): Date {
    if (!orders.length) return startOfDay(new Date());
    const raw = orders[0].date;
    return startOfDay(raw instanceof Date ? raw : new Date(raw as string | number));
}

function promptSendAfterBulk(
    created: ExtendedDocument[] | null | undefined,
    setSelectedCustomersSend: (x: any) => void
) {
    if (!created?.length) return;
    const lst = created.filter((d) => d.type === 'delivery_certificate' || d.type === 'tax_invoice');
    if (!lst.length) return;
    Swal.fire({
        title: 'המסמכים נוצרו בהצלחה',
        text: 'לשלוח בדוא״ל או בווטסאפ?',
        icon: 'success',
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: 'מייל',
        denyButtonText: 'ווטסאפ',
        cancelButtonText: 'סגור',
    }).then((r) => {
        if (!r.isConfirmed && !r.isDenied) return;
        const defaultPlatform = r.isConfirmed ? 'email' : 'whatsapp';
        setSelectedCustomersSend({
            selected: lst.map((u) => Number(u.entId)),
            defaultPlatform,
            files: {
                ids: lst.map((u) => Number(u.id)),
                types: lst.map((u) => u.nkObject.getConnectedDocType()),
            },
            msg: '#docs',
            subject: 'שליחת מסמכים',
        });
    });
}

function chooseOrderOrTodayDateThen(
    goodNodes: ExtendedDocument[],
    onOrderDate: () => void,
    onToday: () => void,
    onAdvanced: () => void
) {
    Swal.fire({
        title: 'תאריך למסמך',
        text:
            goodNodes.length > 1
                ? `נבחרו ${goodNodes.length} הזמנות. "תאריך כמו ההזמנה" — תאריך מסמך לפי כל הזמנה בנפרד. "תאריך היום" — אותו תאריך לכולן.`
                : undefined,
        icon: 'question',
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: 'תאריך כמו ההזמנה',
        denyButtonText: 'תאריך היום',
        cancelButtonText: 'בחר תאריך אחר…',
    }).then((r) => {
        if (r.isConfirmed) onOrderDate();
        else if (r.isDenied) onToday();
        else if (r.dismiss === Swal.DismissReason.cancel) onAdvanced();
    });
}

type BulkDvFromOrder = (opts: {
    docs: ExtendedDocument[];
    date: Date;
    afterSuccess?: (created: ExtendedDocument[]) => void;
    /** When true, each new document uses that row's order date (bulk). */
    useEachOrderDate?: boolean;
}) => void;

const contextMenu = (
    params,
    setCreateDocOpen,
    setDocumentAction,
    setSelectedCustomersSend,
    bulkDvFromOrder?: BulkDvFromOrder,
    setChangeClientDoc?: (doc: ExtendedDocument) => void,
    setPaymentLink?: (payload: {clientId: number; amount: number; invoiceIds: number[]} | null) => void,
) => {
    const hideContextMenu = () => {
        params?.api?.hidePopupMenu?.();
    };

    const ranges = params?.api?.getCellRanges();
    const range = ranges?.length > 0 ? ranges[0] : null;
    const startRowIndex = range?.startRow.rowIndex < range?.endRow.rowIndex ? range?.startRow.rowIndex : range?.endRow.rowIndex;
    const endRowIndex = range?.endRow.rowIndex > range?.startRow.rowIndex ? range?.endRow.rowIndex : range?.startRow.rowIndex;
    let nodesInRange: any = [];
    const nodesInRangeSet: any = new Set();
    const selected = getSelectedRows(params?.api)

    selected?.forEach((row) => {

        if (row && !nodesInRangeSet.has(row)) {
            nodesInRangeSet.add(row);
            nodesInRange.push(row);
        }
    })
    if(!selected.length) {
        ranges?.forEach((range) => {

            const startRowIndex = range?.startRow.rowIndex < range?.endRow.rowIndex ? range?.startRow.rowIndex : range?.endRow.rowIndex;
            const endRowIndex = range?.endRow.rowIndex > range?.startRow.rowIndex ? range?.endRow.rowIndex : range?.startRow.rowIndex;
            for (let i = startRowIndex; i <= endRowIndex; i++) {
                const row = params.api?.getDisplayedRowAtIndex(i);

                if (row?.allLeafChildren) {
                    row?.allLeafChildren?.forEach((child) => {
                        if (!nodesInRangeSet.has(child?.data)) {
                            nodesInRangeSet.add(child?.data);
                            nodesInRange.push(child?.data);
                        }
                    })
                } else {
                    if (!nodesInRangeSet.has(row?.data)) {
                        nodesInRangeSet.add(row?.data);
                        nodesInRange.push(row?.data);
                    }
                }


            }
        });
    }
    const rowData = params.api?.getDisplayedRowAtIndex(startRowIndex)?.data;

    let allOrders = true;
    let allOfTheSameCustomer = true;
    let allInvoice = true;
    let allDeliveryCertificates = true;
    let customerId = rowData?.entId;


    if (nodesInRange.length > 0) {
        for (let node of nodesInRange) {
            if (allOrders && node?.type !== "order") {
                allOrders = false;
            }
            if (allInvoice && node?.type !== "invoice") {
                allInvoice = false;
            }
            // if (allOfTheSameCustomer && node?.entId !== customerId) {
            //     allOfTheSameCustomer = false;
            // }
            if (allDeliveryCertificates && node?.type !== "delivery_certificate" ) {
                allDeliveryCertificates = false;
            }

            if (!allOrders && !allInvoice && !allOfTheSameCustomer && !allDeliveryCertificates) {
                break;
            }
        }
    } else {
        allOrders = false;
        allOfTheSameCustomer = false;
        allInvoice = false;
        allDeliveryCertificates = false;
    }
    const afterBulk = (c: ExtendedDocument[]) => promptSendAfterBulk(c, setSelectedCustomersSend);

    const ordersActions = [
        {
            name: (startRowIndex !== endRowIndex && allOrders) ? "הנפק תעודות משלוח מהזמנות" : "הנפק תעודת משלוח מהזמנה",
            action() {
                const goodNodes = nodesInRange.filter((n) => n.status == 'open' && n.type == 'order')
                if (allOrders && goodNodes.length > 1) {
                    chooseOrderOrTodayDateThen(
                        goodNodes,
                        () =>
                            bulkDvFromOrder?.({
                                docs: goodNodes,
                                date: startOfDay(new Date()),
                                afterSuccess: afterBulk,
                                useEachOrderDate: true,
                            }),
                        () => bulkDvFromOrder?.({docs: goodNodes, date: startOfDay(new Date()), afterSuccess: afterBulk}),
                        () => setDocumentAction({
                            docs: goodNodes,
                            action: "create",
                            doc_type: "order",
                            title: "צור תעודות עבור ההזמנות",
                            afterSuccess: afterBulk,
                        })
                    );
                } else if (allOrders && goodNodes.length == 1) {
                    chooseOrderOrTodayDateThen(
                        goodNodes,
                        () => setCreateDocOpen({
                            documents: goodNodes[0],
                            type: "delivery_certificate",
                            manyProducts: goodNodes[0]?.products,
                            initialDocumentDate: orderDateForDocs(goodNodes),
                            markFromOrder: true,
                        }),
                        () => setCreateDocOpen({
                            documents: goodNodes[0],
                            type: "delivery_certificate",
                            manyProducts: goodNodes[0]?.products,
                            initialDocumentDate: startOfDay(new Date()),
                            markFromOrder: true,
                        }),
                        () => setCreateDocOpen({
                            documents: goodNodes[0],
                            type: "delivery_certificate",
                            manyProducts: goodNodes[0]?.products,
                            markFromOrder: true,
                        }),
                    );
                }

            },
            disabled: (startRowIndex !== endRowIndex && !allOrders)
        },  {
            name: (startRowIndex !== endRowIndex && allOrders) ? "הנפק חשבונית מהזמנות" : "הנפק חשבונית מהזמנה",
            action() {
                const goodNodes = nodesInRange.filter((n) => n.status == 'open' && n.type == 'order')
                if (allOrders && goodNodes.length > 1) {
                    chooseOrderOrTodayDateThen(
                        goodNodes,
                        () =>
                            bulkDvFromOrder?.({
                                docs: goodNodes,
                                date: startOfDay(new Date()),
                                afterSuccess: afterBulk,
                                useEachOrderDate: true,
                            }),
                        () => bulkDvFromOrder?.({docs: goodNodes, date: startOfDay(new Date()), afterSuccess: afterBulk}),
                        () => setDocumentAction({
                            docs: goodNodes,
                            action: "create",
                            doc_type: "order",
                            title: "צור תעודות עבור ההזמנות",
                            afterSuccess: afterBulk,
                        })
                    );
                } else if (allOrders && goodNodes.length == 1) {
                    chooseOrderOrTodayDateThen(
                        goodNodes,
                        () => setCreateDocOpen({
                            documents: goodNodes[0],
                            type: 'invoice',
                            manyProducts: goodNodes[0]?.products,
                            initialDocumentDate: orderDateForDocs(goodNodes),
                            markFromOrder: true,
                        }),
                        () => setCreateDocOpen({
                            documents: goodNodes[0],
                            type: 'invoice',
                            manyProducts: goodNodes[0]?.products,
                            initialDocumentDate: startOfDay(new Date()),
                            markFromOrder: true,
                        }),
                        () => setCreateDocOpen({
                            documents: goodNodes[0],
                            type: 'invoice',
                            manyProducts: goodNodes[0]?.products,
                            markFromOrder: true,
                        }),
                    );
                }

            },
            disabled: (startRowIndex !== endRowIndex && !allOrders)
        },
        {
            name: "העבר הזמנות לתאריך אחר",
            action() {
                const goodNodes = nodesInRange.filter((n) => n.status == 'open' && n.type == 'order')
                if (goodNodes.length > 0)
                    setDocumentAction({
                        docs: goodNodes,
                        action: "move",
                        doc_type: "order",
                        title: "העבר הזמנות לתאריך אחר",
                    })
            },
            disabled: !allOrders
        },

    ];

    const invoiceActions = [
        {
            name: "צור קבלה חדשה",
            action() {
                setCreateDocOpen({
                    documents: nodesInRange,
                    type: "receipt",
                });
            },
            disabled: !allOfTheSameCustomer || !allInvoice
        }
    ];

    const deliveryCertificateActions = [
        {
            name: "הנפק חשבונית מס",
            action() {
                const goodNodes = nodesInRange.filter((n) => n.status == 'open' && n.type == 'delivery_certificate')
                if (goodNodes.length > 0)
                    setCreateDocOpen({
                        documents: goodNodes,
                        type: "invoice"
                    });
            },
            disabled: !allDeliveryCertificates
        }
    ];

    const contextMenuItems: ({
        name: string;
        subMenu?: {
            name: string;
            action: () => void;
            disabled?: boolean;
        }[];
        action?: () => void;
        disabled?: boolean;
    } | string)[] = [];

    if (allOrders) {
        contextMenuItems.push(...ordersActions, "separator");
    }

    if (false && allOfTheSameCustomer && allInvoice) {
        contextMenuItems.push(...invoiceActions, "separator");
    }

    if (allOfTheSameCustomer && allDeliveryCertificates) {
        contextMenuItems.push(...deliveryCertificateActions, "separator");
    }

    const hashIsraelTaxTypes = new Set(['invoice', 'refund', 'tax_invoice', 'sup_invoice', 'sup_refund', 'sup_tax_invoice']);
    const hashIsraelDocs = nodesInRange.filter(
        (n) => hashIsraelTaxTypes.has(n?.type) && n?.status !== 'canceled'
    );
    const heshIsraelEnabled = JSDB().getUser().first?.hesh_israel === 1;

    const hashIsraelActions = heshIsraelEnabled && hashIsraelDocs.length > 0 ? [
        {
            name: hashIsraelDocs.length > 1 ? 'מספר הקצאה לחשבוניות' : 'מספר הקצאה לחשבונית',
            action() {
                Swal.fire({
                    title: 'מספר הקצאה (חשבונית ישראל)',
                    text: `לחתום ${hashIsraelDocs.length} חשבוניות במערכת מס הקצאה?`,
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'המשך',
                    cancelButtonText: 'ביטול',
                }).then(async (r) => {
                    if (!r.isConfirmed) return;
                    Swal.fire({
                        title: 'מבצע חתימה…',
                        allowOutsideClick: false,
                        didOpen: () => Swal.showLoading(),
                    });
                    try {
                        const ids = hashIsraelDocs.map((d) => Number(d.id));
                        const types = hashIsraelDocs.map((d) => d.nkObject.getConnectedDocType());
                        const sup = hashIsraelDocs.every((d) => isSupplierDocument(d.type));
                        const results = await hashIsraelSignBulk({ids, types, sup: sup || undefined});
                        Swal.close();
                        if (!results) {
                            await Swal.fire({
                                title: 'נדרש חיבור לחשבונית ישראל',
                                icon: 'warning',
                            });
                            return;
                        }
                        const succeeded = results.filter((x) => x.doc?.taxConfirmation);
                        const failed = results.filter((x) => x.error);
                        const skipped = results.length - succeeded.length - failed.length;
                        if (failed.length === 0) {
                            await Swal.fire({
                                title: 'הושלם',
                                html: `עודכנו ${succeeded.length} חשבוניות${skipped ? `<br/>דולגו ${skipped} (מתחת לסף / כבר חתומות)` : ''}`,
                                icon: 'success',
                            });
                        } else {
                            await Swal.fire({
                                title: 'הושלם עם שגיאות',
                                html: `הצליחו: ${succeeded.length}<br/>נכשלו: ${failed.length}${skipped ? `<br/>דולגו: ${skipped}` : ''}<br/><br/>${failed.slice(0, 5).map((f) => f.error).join('<br/>')}`,
                                icon: 'warning',
                            });
                        }
                    } catch (e: any) {
                        Swal.close();
                        await Swal.fire({
                            title: 'שגיאה בחתימת חשבוניות',
                            text: e?.message ?? 'אירעה שגיאה',
                            icon: 'error',
                        });
                    }
                });
            },
        },
    ] : [];

    const massSend = [
        {
            name: "שלח מסמכים למייל",
            icon: `<img src="${email}" style="width: 20px; height: 20px; margin-right: 5px;"/>`,
            action() {
                const lst = [...nodesInRange]
                setSelectedCustomersSend({
                    selected: lst.map((u) => Number(u.entId)),
                    defaultPlatform: 'email',
                    files: massSendFilesOf(lst),
                    msg: '#docs',
                    subject: 'שליחת מסמכים',
                })

                hideContextMenu();
            },
        },
        {
            name: "שלח תעודות לווטסאפ",
            icon: `<img src="${whatsapp2}" style="width: 20px; height: 20px; margin-right: 5px;"/>`,
            action() {
                const lst = [...nodesInRange]
                setSelectedCustomersSend({
                    selected: lst.map((u) => Number(u.entId)),
                    defaultPlatform: 'whatsapp',
                    files: massSendFilesOf(lst),
                    msg: '#docs',
                    subject: 'שליחת מסמכים',
                })

                hideContextMenu();
            },
        },
        {
            name: "פתח וואטסאפ ללקוח",
            icon: `<img src="${whatsapp2}" style="width: 20px; height: 20px; margin-right: 5px;"/>`,
            action() {
                hideContextMenu();
                const doc = nodesInRange[0] ?? rowData;
                const entity = doc && isSupplierDocument(doc.type)
                    ? JSDB().getSupplier(Number(doc.entId))?.first
                    : JSDB().getClient(Number(doc?.entId))?.first;
                const phone = entity?.getPhone?.();
                const validPhone = phone ? JSDB().getValidPhone(phone) : '';
                if (!validPhone) {
                    Swal.fire({
                        title: 'אין מספר טלפון ללקוח',
                        icon: 'warning',
                    });
                    return;
                }
                window.open(`https://api.whatsapp.com/send?phone=${validPhone}`, '_blank')?.focus();
            },
        },
        ...(getTranzilaConfig() && !nodesInRange.some((n) => isSupplierDocument(n?.type))
            ? (() => {
                const groups = groupPayableByClient(collectPayableDocsFromDocuments(nodesInRange));
                const items: {name: string; icon?: string; action: () => void}[] = [];
                if (groups.length) {
                    items.push({
                        name: 'תשלום בלינק',
                        icon: `<img src="${whatsapp2}" style="width: 20px; height: 20px; margin-right: 5px;"/>`,
                        action() {
                            hideContextMenu();
                            setSelectedCustomersSend(paymentSendPayload(groups));
                        },
                    });
                }
                if (groups.length === 1 && setPaymentLink) {
                    items.push({
                        name: 'צור קישור תשלום',
                        action() {
                            hideContextMenu();
                            setPaymentLink({
                                clientId: groups[0].clientId,
                                amount: groups[0].amount,
                                invoiceIds: groups[0].docs
                                    .filter((doc) => doc?.type === 'invoice')
                                    .map((doc) => Number(doc.id))
                                    .filter((id) => Number.isFinite(id) && id > 0),
                            });
                        },
                    });
                }
                if (!groups.length) {
                    items.push({
                        name: 'תשלום בלינק',
                        icon: `<img src="${whatsapp2}" style="width: 20px; height: 20px; margin-right: 5px;"/>`,
                        action() {
                            hideContextMenu();
                            Swal.fire({
                                icon: 'info',
                                title: 'אין יתרה לתשלום',
                                text: 'סמן חשבוניות פתוחות או תעודות משלוח עם סכום, ואז שלח בלינק.',
                            });
                        },
                    });
                }
                return items;
            })()
            : []),
    ];

    contextMenuItems.push(...massSend, "separator");
    if (hashIsraelActions.length > 0) {
        contextMenuItems.push(...hashIsraelActions, "separator");
    }
    const canChangeClientEnt = true;
    const singleDeliveryCert =
        nodesInRange.length === 1 && nodesInRange[0]?.type === 'delivery_certificate';
    if (canChangeClientEnt && singleDeliveryCert && setChangeClientDoc) {
        contextMenuItems.push({
            name: 'שינוי לקוח',
            action() {
                setChangeClientDoc(nodesInRange[0]);
            },
        }, 'separator');
    }


    return contextMenuItems;
}


export const contextMenuProducts = (params, setCreateDocOpen, setDocumentAction, setSelectedCustomersSend) => {
    const hideContextMenu = () => {
        params?.api?.hidePopupMenu?.();
    };

    const ranges = params?.api?.getCellRanges();
    const range = ranges?.length > 0 ? ranges[0] : null;
    const startRowIndex = range?.startRow.rowIndex < range?.endRow.rowIndex ? range?.startRow.rowIndex : range?.endRow.rowIndex;
    const endRowIndex = range?.endRow.rowIndex > range?.startRow.rowIndex ? range?.endRow.rowIndex : range?.startRow.rowIndex;
    let nodesInRange: any = [];
    const nodesInRangeSet: any = new Set();

    ranges?.forEach((range) => {
        const startRowIndex = range?.startRow.rowIndex < range?.endRow.rowIndex ? range?.startRow.rowIndex : range?.endRow.rowIndex;
        const endRowIndex = range?.endRow.rowIndex > range?.startRow.rowIndex ? range?.endRow.rowIndex : range?.startRow.rowIndex;
        for (let i = startRowIndex; i <= endRowIndex; i++) {
            const row = params.api?.getDisplayedRowAtIndex(i);
            if (!nodesInRangeSet.has(row?.data)) {
                nodesInRangeSet.add(row?.data);
                nodesInRange.push(row?.data);
            }

        }
    });
    const rowData = params.api?.getDisplayedRowAtIndex(startRowIndex)?.data;

    let allOrders = true;
    let allOfTheSameCustomer = true;
    let allInvoice = true;
    let allDeliveryCertificates = true;
    let customerId = rowData?.c_id;


    if (nodesInRange.length > 0) {
        for (let node of nodesInRange) {
            if (allOrders && node?.doc_type !== "order") {
                allOrders = false;
            }
            if (allInvoice && node?.doc_type !== "invoice") {
                allInvoice = false;
            }
            // if (allOfTheSameCustomer && node?.c_id !== customerId) {
            //     allOfTheSameCustomer = false;
            // }
            if (allDeliveryCertificates && node?.note.type !== "delivery_certificate" || node?.status == "closed") {
                allDeliveryCertificates = false;
            }

            if (!allOrders && !allInvoice && !allOfTheSameCustomer && !allDeliveryCertificates) {
                break;
            }
        }
    } else {
        allOrders = false;
        allOfTheSameCustomer = false;
        allInvoice = false;
        allDeliveryCertificates = false;
    }
    const ordersActions = [
        {
            name: (startRowIndex !== endRowIndex && allOrders) ? "הנפק תעודות משלוח מהזמנות" : "הנפק תעודת משלוח מהזמנה",
            action() {
                const goodNodes = nodesInRange.filter((n) => n.status == 'open' && n.type == 'order')
                if (allOrders && goodNodes.length > 1) {
                    setDocumentAction({
                        docs: goodNodes,
                        action: "create",
                        doc_type: "order",
                        title: "צור תעודות עבור ההזמנות",
                    })
                } else if (allOrders && goodNodes.length == 1) {

                    setCreateDocOpen({
                        documents: goodNodes[0],
                        type: "delivery_certificate",
                        manyProducts: goodNodes[0]?.products
                    });
                }

            },
            disabled: (startRowIndex !== endRowIndex && !allOrders)
        },
        {
            name: "העבר הזמנות לתאריך אחר",
            action() {
                const goodNodes = nodesInRange.filter((n) => n.status == 'open' && n.type == 'order')
                if (goodNodes.length > 0)
                    setDocumentAction({
                        docs: goodNodes,
                        action: "move",
                        doc_type: "order",
                        title: "העבר הזמנות לתאריך אחר",
                    })
            },
            disabled: !allOrders
        },

    ];

    const invoiceActions = [
        {
            name: "צור קבלה חדשה",
            action() {
                setCreateDocOpen({
                    documents: nodesInRange,
                    type: "receipt",
                });
            },
            disabled: !allOfTheSameCustomer || !allInvoice
        }
    ];

    const deliveryCertificateActions = [
        {
            name: "הנפק חשבונית מס",
            action() {
                let goodNodes = nodesInRange.filter((n) => n.status == 'open' && n.note.type == 'delivery_certificate')
                goodNodes = distinctByField(goodNodes, 'doc_id');

                goodNodes = goodNodes.map((d) => d.note)
                if (goodNodes.length > 0)
                    setCreateDocOpen({
                        documents: goodNodes,
                        type: "invoice"
                    });
            },
            disabled: !allDeliveryCertificates
        }
    ];

    const contextMenuItems: ({
        name: string;
        subMenu?: {
            name: string;
            action: () => void;
            disabled?: boolean;
        }[];
        action?: () => void;
        disabled?: boolean;
    } | string)[] = [];

    if (false && allOrders) {
        contextMenuItems.push(...ordersActions, "separator");
    }

    if (false && allOfTheSameCustomer && allInvoice) {
        contextMenuItems.push(...invoiceActions, "separator");
    }

    if (allOfTheSameCustomer && allDeliveryCertificates) {
        contextMenuItems.push(...deliveryCertificateActions, "separator");
    }
    const massSend = [
        {
            name: "שלח מסמכים למייל",
            icon: `<img src="${email}" style="width: 20px; height: 20px; margin-right: 5px;"/>`,
            action() {

                let goodNodes = distinctByField(nodesInRange, 'c_id').map((d) => d.note);
                const lst = [...goodNodes]
                setSelectedCustomersSend({
                    selected: lst.map((u) => Number(u.entId)),
                    defaultPlatform: 'email',
                    files: massSendFilesOf(lst),
                    msg: '#docs',
                    subject: 'שליחת מסמכים',
                })

                hideContextMenu();
            },
        },
        {
            name: "שלח תעודות לווטסאפ",
            icon: `<img src="${whatsapp2}" style="width: 20px; height: 20px; margin-right: 5px;"/>`,
            action() {
                let goodNodes = distinctByField(nodesInRange, 'c_id').map((d) => d.note);
                const lst = [...goodNodes]
                setSelectedCustomersSend({
                    selected: lst.map((u) => Number(u.entId)),
                    defaultPlatform: 'whatsapp',
                    files: massSendFilesOf(lst),
                    msg: '#docs',
                    subject: 'שליחת מסמכים',
                })

                hideContextMenu();
            },
        },
    ];
    contextMenuItems.push(...massSend, "separator");


    return contextMenuItems;
}


export default contextMenu;
